import { BasePage } from './../../base.page';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoadingController, ToastController, Platform } from '@ionic/angular';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'shc-new-password',
  templateUrl: './new-password.page.html',
  styleUrls: ['./new-password.page.scss'],
})
export class NewPasswordPage extends BasePage implements OnInit {
  code: number;
  email: string;
  form: UntypedFormGroup;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
    this.route.params.subscribe(res => {
      this.code = this.router.getCurrentNavigation().extras?.state?.code;
      this.email = this.router.getCurrentNavigation().extras?.state?.email;
    });
  }

  password = new UntypedFormControl(null,
    Validators.compose([Validators.required, Validators.minLength(8)])
  );

  passwordConfirmation = new UntypedFormControl(null, (control: AbstractControl) => {
    if (this.password.valid && control.value !== this.password.value) {
      return { confirmed: true };
    }
    return null;
  });

  ngOnInit() {
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl(null),
      password: this.password,
      password_confirmation: this.passwordConfirmation,
      reset_password_token: new UntypedFormControl(null)
    });
  }

  onResetPassword() {
    this.form.patchValue({
      email: this.email,
      reset_password_token: this.code
    });
    this.loadingCtrl.create({
      message: this.translate.instant(marker('Loading'))
    }).then(loadingEl => {
      loadingEl.present();
      this.authService.reset(this.form.value).subscribe(
        (res: any) => {
          loadingEl.dismiss();
          this.router.navigate(['/auth/login']);
        },
        error => {
          loadingEl.dismiss();
          this.errorService.handle(error);
        }
      );
    });
  }

}
